import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { USD } from '../../../../constants/currency-codes';
import { FormattedCurrency } from '../../../formatted-currency';

const defaultOrderTotal = {
  value: 0,
  code: USD,
};

export const getSummarySectionSummary = (open, orderDate, amountSummary) => {
  if (open) {
    return undefined;
  }

  const orderTotal = amountSummary.orderTotal || defaultOrderTotal;
  const { value, code } = orderTotal;

  return (
    <FormattedMessage
      {...messages.closedHeader}
      values={{
        orderDate,
        orderTotal: <FormattedCurrency currencyCode={code} value={value} />,
      }}
    />
  );
};
